/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
// eslint-disable-next-line import/no-extraneous-dependencies
import { CopyToClipboard } from 'react-copy-to-clipboard'

import './index.scss'
import { blue } from '@material-ui/core/colors'

const CarSpecifications = props => {
    const { threadDetails, firstMessage } = props
    const [conversationId, setConversationId] = useState('')
    const [leadInfo, setLeadInfo] = useState(null)

    const [accountId, setAccountId] = useState('')

    // Try to get VIN from first message
    const [conversationVIN, setConversationVIN] = useState('')

    useEffect(() => {
        if (!threadDetails || !firstMessage) {
            return
        }

        const {
            AccountId, Vin, LeadInfo, ConversationId
        } = firstMessage

        if (AccountId) {
            setAccountId(AccountId)
        }

        if (Vin) {
            setConversationVIN(Vin)
        }

        if (ConversationId) {
            setConversationId(ConversationId)
        }

        if (LeadInfo) {
            try {
                const parsed = JSON.parse(LeadInfo)

                if (parsed && parsed.lead_id && parsed.customer_id) {
                    setLeadInfo(parsed)
                }
            } catch (e) {
                console.log('Cannot parse leadInfo')
            }
        }
    }, [threadDetails, firstMessage])

    function format(node, level) {
        const indentBefore = new Array(level++ + 1).join('  ')
        const indentAfter = new Array(level - 1).join('  ')
        let textNode

        for (let i = 0; i < node.children.length; i++) {
            textNode = document.createTextNode('\n' + indentBefore)
            node.insertBefore(textNode, node.children[i])

            format(node.children[i], level)

            if (node.lastElementChild === node.children[i]) {
                textNode = document.createTextNode('\n' + indentAfter)
                node.appendChild(textNode)
            }
        }

        return node
    }

    function process(str) {
        const div = document.createElement('div')
        div.innerHTML = str.trim()

        return format(div, 0).innerHTML
    }

    const openContentInNewTab = content => {
        const newPage = window.open()
        let formattedString
        try {
            formattedString = process(content)
        } catch (err) {
            formattedString = content
        }
        const formattedNode = `
            <xmp>
                ${formattedString}
            </xmp>
        `
        newPage.document.write(formattedNode)
    }

    // const { answerTemplateLink } = props
    return (
        <div className='CarSpecifications'>
            <div className='Details__row'>
                <p>Cylinders</p>
                <p>{threadDetails.cylinders}</p>
            </div>
            <div className='Details__row'>
                <p>Drivetrain</p>
                <p>{threadDetails.drivetrain}</p>
            </div>
            <div className='Details__row'>
                <p>VIN number</p>
                <p>{threadDetails.vinNumber || conversationVIN}</p>
            </div>
            <div className='Details__row'>
                <p>Miles</p>
                <p>{threadDetails.miles}</p>
            </div>
            <div className='Details__row'>
                <p>Exterior</p>
                <p>{threadDetails.exteriorColor}</p>
            </div>
            <div className='Details__row'>
                <p>Interior</p>
                <p>{threadDetails.interiorColor}</p>
            </div>

            <div className='Details__row'>
                <p>Engine</p>
                <p>{threadDetails.engine}</p>
            </div>
            <div className='Details__row'>
                <p>Url</p>
                <p>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href={threadDetails.carUrl}
                    >
                        View
                    </a>
                </p>
            </div>
            <div className='Details__row'>
                <p>Full specs</p>
                <p>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href={`/api/vehicles?vin=${threadDetails.carId}&accountId=${accountId}`}
                    >
                        View
                    </a>
                </p>
            </div>
            {leadInfo && (
                <div className='Details__row'>
                    <p>Vinsolutions link</p>
                    <p>
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            // eslint-disable-next-line max-len
                            href={`/api/links/vinsolutions?leadId=${leadInfo.lead_id}&customerId=${leadInfo.customer_id}`}>
                            Open
                        </a>
                    </p>
                </div>
            )}
            {conversationId && (
                <div className='Details__row'>
                    <p>Assistant link</p>
                    <p>
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href={`/api/links/assistant?id=${conversationId}`}
                        >
                            Open
                        </a>
                    </p>
                </div>
            )}
            {/* {answerTemplateLink && ( */}
            {/*     <div className='Details__row'> */}
            {/*         <p>Answers link</p> */}
            {/*         <p> */}
            {/*             <a */}
            {/*                 target='_blank' */}
            {/*                 rel='noopener noreferrer' */}
            {/*                 href={`${answerTemplateLink}`} */}
            {/*             > */}
            {/*                 Open */}
            {/*             </a> */}
            {/*         </p> */}
            {/*     </div> */}
            {/* )} */}
            <div className='Details__row'>
                <p>
                    <span style={{ color: blue }}>Conversation Link</span>
                </p>
                <CopyToClipboard
                    text={`${
                        window.location.hash.length > 0
                            ? window.location.href
                            : `${window.location.href}#${conversationId}`
                    }`}
                >
                    <p>
                        {' '}
                        <span style={{ color: '#0000EE', cursor: 'pointer' }}>
                            Copy
                        </span>
                    </p>
                </CopyToClipboard>
            </div>
            {props.adf && (
                <div className='Details__row'>
                    <p>Adf</p>
                    <p>
                        <span
                            style={{ color: '#0000EE', cursor: 'pointer' }}
                            onClick={() => openContentInNewTab(props.adf)}
                        >
                            Open
                        </span>
                    </p>
                </div>
            )}
        </div>
    )
}

const mapStateToProps = ({ operatorDashboardDetails, operatorDashboard }) => {
    const answerTemplateLink = operatorDashboardDetails.dealershipDetails.AnswerTemplateLink
    const { adf } = operatorDashboard
    return {
        answerTemplateLink,
        adf,
    }
}

export default connect(mapStateToProps)(CarSpecifications)
